module.exports = __webpack_public_path__ + "img/023.b134b918.jpg";